import CSS from "./styles.module.css";

// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ActionBoxCTA from "../ActionBoxCTA/ActionBoxCTA";

const MoreTools = ({ ref }) => {
	useEffect(() => {
		AOS.init({ duration: 500, delay: 0 });
	}, []);

	return (
		<div className={CSS.MoreToolsContainer} ref={ref} data-aos="fade-up">
			<div className={CSS.MoreTools}>
				<div className={CSS.Heading}>
					<h3>Explore Our More AI Hiring Tools</h3>
				</div>
				<div className={CSS.MTContainer}>
					<div className={CSS.ActionBox}>
						<ActionBoxCTA
							icon="unknown_document"
							heading="AI Interview Questions Generator"
							content="Transform the way you interview candidates and test their true potential with our AI Interview Questions Generator."
							button="Try for free"
							link="https://recooty.com/tools/interview-question-generator/"
							linkTarget="_blank"
							className={CSS.ActionBox3}
						/>

						<div className={CSS.ActionSubBox}>
							<ActionBoxCTA
								icon="description"
								heading="AI Job Description Generator"
								content="Supercharge your job listings with our AI Job Description Generator. Boost visibility and attract top talent effortlessly. "
								button="Try for free"
								link="https://recooty.com/tools/job-description-generator/"
								linkTarget="_blank"
							/>

							<ActionBoxCTA
								icon="clinical_notes"
								heading="Employee Onboarding Poster Creator"
								content="Revamp Onboarding with Our Employee Poster Creator. Streamline the process and welcome new hires effectively. "
								button="Create now"
								link="https://recooty.com/tools/welcome-employee-graphic/"
								linkTarget="_blank"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MoreTools;
